import React, { useEffect } from 'react';
import Planos from 'components/organisms/planos';
import { track } from 'services/tracking';

const PlanosPrecos = () => {
  useEffect(() => {
    track('intencao.acessou_pagina_vendas', { origem: 'planos_precos' });
  }, []);

  return (
    <div className="page-container">
      <Planos viewPage="" dadosPlanCheckout={undefined} />
    </div>
  );
};
export default PlanosPrecos;
